export default "https://webapi.virdarteb.com/api/";
